import React from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import { checkIsActive } from 'src/_metronic/_helpers';

export const SubMenu = ({ submenu }) => {
	const location = useLocation();
  const { pathname } = location;
	const ordered = submenu.sort((a, b) => a.seq < b.seq && -1);

	const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url)
        ? ` ${!hasSubmenu && "menu-item-active"} menu-item-open `
        : "";
  };

  return (
		<div className='menu-submenu'>
			<ul className='menu-subnav'>
				{ordered.map(sItem => (
					<li key={sItem.id} className={`menu-item${sItem.submodules && sItem.submodules.length > 0 ? getMenuItemActive(sItem.slug, true) : getMenuItemActive(sItem.slug, false)}`}>
						<NavLink
							className={`${'menu-link menu-toggle'} ${
								sItem.slug === pathname.substring(1) ? 'activeItemMenu' : ''
							}`}
							to={`${sItem.slug}`}
						>
							<i className='menu-bullet menu-bullet-dot'>
								<span />
							</i>
							<span className='menu-text'>{sItem.display_text}</span>
							{sItem.submodules && sItem.submodules.length > 0 && (
								<i className='menu-arrow' />
							)}
						</NavLink>
						{sItem.submodules && sItem.submodules.length > 0 && (
							<SubMenu submenu={sItem.submodules} />
						)}
					</li>
				))}
			</ul>
		</div>
	);
}
